<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="来源" prop="status">
        <a-select v-model="form.status" placeholder="请选择用户端/师傅端" @change="onStatusChange">
          <a-select-option :value="0">用户端</a-select-option>
          <a-select-option :value="1">师傅端</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="消息类型" prop="type">
        <a-select v-model="form.type" placeholder="请选择消息类型" @change="onTypeChange">
          <a-select-option :value="0">平台公告</a-select-option>
          <a-select-option :value="1">系统消息</a-select-option>
          <a-select-option :value="2">订单消息</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="needSelectReceiver" label="消息接收人" prop="userId">
        <a-select
          v-model="form.userId"
          placeholder="请选择消息接收人"
          allow-clear
          show-search
          :filter-option="filterUserOption"
          :loading="userListLoading"
        >
          <a-select-option v-for="u in userList" :key="u.id" :value="u.id">
            {{ u.nickname || u.mobile || u.id }}
            <span v-if="u.mobile" style="color: #999; margin-left: 8px;">{{ u.mobile }}</span>
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="标题" prop="title">
        <a-input v-model="form.title" placeholder="请输入标题" />
      </a-form-model-item>
      <a-form-model-item label="内容" prop="content">
        <editor v-model="form.content" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getMessage, addMessage, updateMessage } from '@/api/message/message'
import { listByType } from '@/api/biz/user'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      form: {
        id: null,
        status: 0,
        type: undefined,
        taskId: null,
        title: null,
        content: null,
        read: null,
        userId: undefined,
        createTime: null,
        remark: null
      },
      formType: 1,
      open: false,
      userList: [],
      userListLoading: false,
      rules: {
        status: [
          { required: true, message: '状态不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '消息类型不能为空', trigger: 'change' }
        ],
        title: [
          { required: true, message: '标题不能为空', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '内容不能为空', trigger: 'blur' }
        ],
        userId: []
      }
    }
  },
  computed: {
    needSelectReceiver () {
      return this.form.type !== 0 && this.form.type !== undefined && this.form.type !== null
    }
  },
  watch: {
    needSelectReceiver: {
      handler (val) {
        if (val) {
          this.rules.userId = [{ required: true, message: '请选择消息接收人', trigger: 'change' }]
          this.loadUserList()
        } else {
          this.form.userId = null
          this.rules.userId = []
        }
      }
    }
  },
  methods: {
    onStatusChange () {
      this.form.userId = null
      if (this.needSelectReceiver) {
        this.loadUserList()
      }
    },
    onTypeChange () {
      if (!this.needSelectReceiver) {
        this.form.userId = null
        this.rules.userId = []
      } else {
        this.rules.userId = [{ required: true, message: '请选择消息接收人', trigger: 'change' }]
        this.loadUserList()
      }
    },
    loadUserList () {
      if (this.form.status === undefined || this.form.status === null) return
      this.userListLoading = true
      listByType({ type: this.form.status, status: 1 }).then(res => {
        const data = res.data
        if (Array.isArray(data)) {
          this.userList = data
        } else if (data && data.list) {
          this.userList = data.list
        } else if (data && data.records) {
          this.userList = data.records
        } else {
          this.userList = []
        }
      }).finally(() => {
        this.userListLoading = false
      })
    },
    filterUserOption (input, option) {
      const id = option.componentOptions && option.componentOptions.propsData && option.componentOptions.propsData.value
      const u = this.userList.find(x => x.id === id)
      if (!u) return true
      const text = ((u.nickname || '') + (u.mobile || '')).toLowerCase()
      return text.indexOf((input || '').toLowerCase()) >= 0
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        status: 0,
        type: undefined,
        taskId: null,
        title: null,
        content: null,
        read: null,
        userId: undefined,
        createTime: null,
        remark: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getMessage({ id: id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateMessage(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addMessage(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
